// Shorter aliases for document.querySelector and document.querySelectorAll

export function get(selector) {
	return document.querySelector(selector);
}

export function getAll(selector) {
	return document.querySelectorAll(selector);
}
